import { render, staticRenderFns } from "./CortesXgastos.vue?vue&type=template&id=2f03aaf8"
import script from "./CortesXgastos.vue?vue&type=script&lang=js"
export * from "./CortesXgastos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports